import { render, staticRenderFns } from "./PublishDetail.vue?vue&type=template&id=612a6765&scoped=true&"
import script from "./PublishDetail.vue?vue&type=script&lang=js&"
export * from "./PublishDetail.vue?vue&type=script&lang=js&"
import style0 from "./PublishDetail.vue?vue&type=style&index=0&id=612a6765&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "612a6765",
  null
  
)

export default component.exports